module.exports = __webpack_public_path__ + "img/70.4bc0f821.png";